<div class="emergency-container" [ngClass]="{'aem-style' : isAEMEnvironment}">
  <div class="emergency-container-notifications">
    <div class="emergency-container-notifications-text">
      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 18.5C15.5228 18.5 20 14.4706 20 9.5C20 4.52944 15.5228 0.5 10 0.5C4.47715 0.5 0 4.52944 0 9.5C0 14.4706 4.47715 18.5 10 18.5Z"
          fill="#53565A"
        />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.30005C10 7.05741 10 8.04269 10 9.80005V5.30005Z" fill="white" />
        <path d="M10 5.30005C10 7.05741 10 8.04269 10 9.80005" stroke="#F8E6E6" stroke-width="2" stroke-linecap="round" />
        <path
          d="M10 14C10.5523 14 11 13.597 11 13.1C11 12.6029 10.5523 12.2 10 12.2C9.44772 12.2 9 12.6029 9 13.1C9 13.597 9.44772 14 10 14Z"
          fill="#F8E6E6"
        />
      </svg>
      <span class="emergency-container-notifications-text-content" [ngClass]="{'withEllipsis' : showViewMore}">
        <p [innerHTML]="emergencyText"></p>
      </span>
      <p *ngIf="showViewMore" (click)="toggleModalClicked()" class="link">View More</p>
    </div>
  </div>
  <span (click)="closeAlert()" style="margin-right: 15px; margin-top: 15px" class="emergency-container-button">
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1938 1.47485L1 14.6023Z" fill="#7F736C" />
      <path d="M16.1938 1.47485L1 14.6023" stroke="#767A7D" stroke-width="2" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.20117 1.30005L16.395 14.4275Z" fill="#7F736C" />
      <path d="M1.20117 1.30005L16.395 14.4275" stroke="#767A7D" stroke-width="2" />
    </svg>
  </span>
</div>
